import { useState, useMemo } from 'react';
import { SortOrder } from '../enums';

interface SortingProps {
  defaultOrder: SortOrder;
  defaultOrderBy: string;
}

const useSorting = ({ defaultOrder, defaultOrderBy }: SortingProps) => {
  const [order, setOrder] = useState<SortOrder>(defaultOrder);
  const [orderBy, setOrderBy] = useState<string>(defaultOrderBy);

  return useMemo(() => {
    return {
      order, orderBy, setOrder, setOrderBy,
    };
  }, [order, orderBy, setOrder, setOrderBy]);
};

export default useSorting;
